import { gql } from '@apollo/client';

// get_onboarding_progress
export const GET_ONBOARDING_PROGRESS = gql`
  query get_onboarding_progress {
    response: get_onboarding_progress {
      hasError
      data
      message
    }
  }
`;

export const UPSERT_BUSINESS = gql`
  mutation upsert_business($input: UpsertBusinessInputType!) {
    response: upsert_business(data: $input) {
      hasError
      data
      message
    }
  }
`;

export const UPSERT_WHATSAPP_NUMBER = gql`
  mutation upsert_whatsapp_number($input: UpsertOwnersWhatsappInputType!) {
    response: upsert_whatsapp_number(data: $input) {
      hasError
      data
      message
    }
  }
`;

export const UPDATE_BUSINESS_RULES = gql`
  mutation update_business_rules($input: UpdateBusinessRulesInputType!) {
    response: update_business_rules(data: $input) {
      hasError
      data
      message
    }
  }
`;

export const UPDATE_BUSINESS_BRANDING = gql`
  mutation update_business_branding($input: UpdateBusinessBrandInputType!) {
    response: update_business_branding(data: $input) {
      hasError
      data
      message
    }
  }
`;

export const SUBMIT_AND_GEN_AGENT = gql`
  mutation submit_and_gen_agent($input: SubmitBusinessAndGenAgentInputType!) {
    response: submit_and_gen_agent(data: $input) {
      hasError
      data
      message
    }
  }
`;

export const GENERATE_SUGGESTIONS = gql`
  query generate_suggestions($data: GenerateSuggestionsInputType!) {
    response: generate_suggestions(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const GEN_SHOPIFY_INTEGRATION_CODE = gql`
  mutation gen_shopify_integration_code(
    $input: GenShopifyIntegrationCodeInputType!
  ) {
    response: gen_shopify_integration_code(data: $input) {
      hasError
      data
      message
    }
  }
`;

export const UPDATE_SKIP_SHOPIFY = gql`
  mutation update_skip_shopify($input: UpdateSkipShopifyInputType!) {
    response: update_skip_shopify(data: $input) {
      hasError
      data
      message
    }
  }
`;
